import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import WizardInput from './WizardInput';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AccountForm = ({ register, errors, watch }) => {
 return (
  <>
   <WizardInput
    type="text"
    errors={errors}
    label="Nombre*"
    name="fullName"
    formGroupProps={{ className: 'mb-3' }}
    formControlProps={{
     ...register('fullName', {
      required: 'El campo nombre es requerido',
      pattern: {
       value: /[A-Za-z ]/i,
       message: 'El nombre debe ser válido.'
      }
     })
    }}
   />

   <WizardInput
    type="email"
    errors={errors}
    label="Email*"
    name="email"
    formGroupProps={{ className: 'mb-3' }}
    formControlProps={{
     ...register('email', {
      required: 'Email field is required',
      pattern: {
       value: /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/i,
       message: 'Email must be valid'
      }
     })
    }}
   />

   <Row className="g-2 mb-3">
    <WizardInput
     type="password"
     errors={errors}
     label="Password*"
     name="password"
     formGroupProps={{ as: Col, sm: 6 }}
     formControlProps={{
      ...register('password', {
       required: 'Debe especificar una contraseña',
       minLength: {
        value: 2,
        message: 'La contraseña debe tener al menos 2 caracteres'
       }
      })
     }}
    />
    <WizardInput
     type="password"
     errors={errors}
     label="Confirm Password*"
     name="confirmPassword"
     formGroupProps={{ as: Col, sm: 6 }}
     formControlProps={{
      ...register('confirmPassword', {
       required: 'Este campo es obligatorio',
       validate: value => value === watch('password') || 'La contraseña no coincide'
      })
     }}
    />
   </Row>

   <WizardInput
    type="checkbox"
    errors={errors}
    label={
     <>
      Acepto los <Link to="#!"> términos</Link> y <Link to="#!"> la política de privacidad</Link>
     </>
    }
    name="agreedToTerms"
    formControlProps={{
     ...register('agreedToTerms', {
      required: 'Debe aceptar los términos y la política de privacidad.'
     })
    }}
   />
  </>
 );
};

AccountForm.propTypes = {
 register: PropTypes.func.isRequired,
 errors: PropTypes.object,
 watch: PropTypes.func
};

export default AccountForm;
